import { FrontendLogLevelEnum } from 'graphql/types.generated'
import { useConfiguracoes } from 'hooks/configuracoes'
import { noop } from 'lodash'
import { useMemo } from 'react'

const ORDEM_NIVEIS = [
  FrontendLogLevelEnum.OFF,
  FrontendLogLevelEnum.ERROR,
  FrontendLogLevelEnum.WARN,
  FrontendLogLevelEnum.INFO,
  FrontendLogLevelEnum.DEBUG,
  FrontendLogLevelEnum.TRACE,
]

const deveLogar = (nivel: FrontendLogLevelEnum, nivelConfigurado: FrontendLogLevelEnum): boolean =>
  ORDEM_NIVEIS.indexOf(nivel) <= ORDEM_NIVEIS.indexOf(nivelConfigurado)

const criarEmissorDeLog = (
  nivelDesejado: Exclude<FrontendLogLevelEnum, FrontendLogLevelEnum.OFF>,
  nivelConfigurado: FrontendLogLevelEnum,
  funcaoConsoleDoNavegador: (...argumentos: unknown[]) => void
) => (!deveLogar(nivelDesejado, nivelConfigurado) ? noop : funcaoConsoleDoNavegador)

export function useLogger() {
  const {
    configuracoes: { frontendLogLevel },
  } = useConfiguracoes()

  return useMemo(() => {
    const nivelConfigurado = frontendLogLevel ?? FrontendLogLevelEnum.OFF

    return {
      // eslint-disable-next-line no-console
      error: criarEmissorDeLog(FrontendLogLevelEnum.ERROR, nivelConfigurado, console.error),
      // eslint-disable-next-line no-console
      warn: criarEmissorDeLog(FrontendLogLevelEnum.WARN, nivelConfigurado, console.warn),
      // eslint-disable-next-line no-console
      info: criarEmissorDeLog(FrontendLogLevelEnum.INFO, nivelConfigurado, console.info),
      // eslint-disable-next-line no-console
      debug: criarEmissorDeLog(FrontendLogLevelEnum.DEBUG, nivelConfigurado, console.debug),
      // eslint-disable-next-line no-console
      trace: criarEmissorDeLog(FrontendLogLevelEnum.TRACE, nivelConfigurado, console.trace),
    }
  }, [frontendLogLevel])
}
